import Checkbox, { CheckboxProps } from "@material-ui/core/Checkbox";
import { FieldInputProps } from "formik";
import * as React from "react";

type Props = CheckboxProps & {
    field?: FieldInputProps<string>;
    isTouched?: boolean;
    label?: string;
};

export const CustomCheckbox = ({ style, label, field, checked, onChange, indeterminate, ...props }: Props) => {
    return (
        <div style={{ marginLeft: "none", display: "flex" }}>
            <Checkbox
                value={field?.value}
                name={field?.name}
                onChange={(event: React.ChangeEvent<any>, checked: boolean) => {
                    if (field) {
                        field.onChange(event);
                    }
                    if (onChange) {
                        onChange(event, checked);
                    }
                }}
                onBlur={field?.onBlur}
                aria-label={props["aria-label"]}
                style={style}
                disableRipple
                checked={checked}
                indeterminate={indeterminate}
            />
            {label}
        </div>
    );
};
